import * as React from "react";
import {Component } from "react";

import "./footer.scss";

import {observer} from "mobx-react";
import {ScaleBar} from "../../../core/components/scalebar/scalebar";
import {Attribution} from "../../../core/components/attribution/attribution";
import {Coordinate} from "../../../core/components/coordinate/coordinate";
import MediaQuery from "react-responsive";
import {IAppStore, withStore} from "../../../core/stores/abstract-app-store";

export interface FooterProps {
    store?: IAppStore; // this is injected by withStore
}

@observer
class FooterBase extends Component<FooterProps, any> {

    constructor(props: FooterProps) {
        super(props);
        this.state = {
            search: null
        };
    }

    render(): JSX.Element | null {
        const {store} = this.props;
        if (!store) {
            return null;
        }
        const topic = store.appStore.topic;
        if (!topic) {
            return null;
        }
        return(
            <div className={"geo-app-footer"}>
                <div className={"geo-scalebar-coordinate"}>
                    <ScaleBar config={store.appConfig.scaleBar} />
                    <MediaQuery minWidth={(store.mapViewerConfig.breakpoints.md + 1)}>
                        <Coordinate />
                    </MediaQuery>
                </div>
                <Attribution config={store.appConfig.attribution} />
            </div>
        );
    }
}

export const Footer = withStore(FooterBase);
